/** Dashboard frontend aralığı → stats/CTR API dateRange */
export function mapDashboardDateRangeToStats(range) {
  const map = {
    today: 'today',
    weekly: 'week',
    monthly: 'month',
    yearly: 'year',
    all: 'all',
    week: 'week',
    month: 'month',
    year: 'year',
  };
  return map[range] || 'today';
}

const TR_FOLD_MAP = {
  ç: 'c',
  ğ: 'g',
  ı: 'i',
  ö: 'o',
  ş: 's',
  ü: 'u',
};

/** Arama için: büyük/küçük harf + Türkçe/ASCII eşdeğerleri (eskişehir ≈ eskisehir) */
export function normalizeCampaignSearchText(value) {
  return String(value || '')
    .trim()
    .toLocaleLowerCase('tr-TR')
    .normalize('NFKC')
    .replace(/\u0307/g, '')
    .split('')
    .map((ch) => TR_FOLD_MAP[ch] || ch)
    .join('');
}

export function campaignTitleMatchesSearch(campaign, searchTerm) {
  const term = normalizeCampaignSearchText(searchTerm);
  if (!term) return true;

  const titles = [campaign?.title, campaign?.campaignTitle]
    .map(normalizeCampaignSearchText)
    .filter(Boolean);

  return titles.some((title) => title.includes(term));
}

function normalizeTitle(value) {
  return String(value || '')
    .trim()
    .toLocaleLowerCase('tr-TR')
    .normalize('NFKC')
    .replace(/\u0307/g, '');
}

/**
 * Genel vs bana özel — önce API isPersonalized, yoksa ID/katalog yedekleri.
 */
export function resolveCampaignPersonalized(campaign, context = {}) {
  if (!campaign || typeof campaign !== 'object') return false;

  const flag = campaign.isPersonalized ?? campaign.IsPersonalized ?? campaign.is_personalized;
  if (flag === true || flag === 1 || flag === '1' || String(flag).toLowerCase() === 'true') {
    return true;
  }
  if (flag === false || flag === 0 || flag === '0' || String(flag).toLowerCase() === 'false') {
    return false;
  }

  const id = String(campaign.campaignId || campaign.id || '').trim();
  const title = normalizeTitle(campaign.campaignTitle || campaign.campaignName || campaign.title);

  if (/^campaign_[\d_]+/i.test(id)) return true;

  const { personalCodes, personalTitles } = context;
  if (personalCodes instanceof Set && id && personalCodes.has(id)) return true;
  if (personalTitles instanceof Set && title && personalTitles.has(title)) return true;

  const type = String(campaign.campaignType || campaign.type || '').toLowerCase();
  if (type === 'personal' || type === 'personalized' || type === 'bana-ozel') return true;
  if (type === 'general' || type === 'genel') return false;

  return false;
}

export function buildPersonalCampaignLookup(campaigns) {
  const personalCodes = new Set();
  const personalTitles = new Set();

  (campaigns || []).forEach((campaign) => {
    const codes = [
      campaign?.DiscountOfferCode,
      campaign?.discountOfferCode,
      campaign?.id,
      campaign?.attributeCode,
      campaign?.AttributeCode,
    ];
    codes.forEach((code) => {
      if (code != null && String(code).trim()) {
        personalCodes.add(String(code).trim());
      }
    });

    const title = normalizeTitle(
      campaign?.CampaignTitle || campaign?.campaignTitle || campaign?.title
    );
    if (title) personalTitles.add(title);
  });

  return { personalCodes, personalTitles };
}
